var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowRight = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1.13636,
    y: 1.13636,
    width: 47.7273,
    height: 47.7273,
    rx: 23.8636,
    transform: "matrix(-1 0 0 1 47.7273 0)",
    stroke: "#2D5EFF",
    strokeWidth: 2.27273
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2182 26.3736C17.2994 26.3866 17.3815 26.3926 17.4637 26.3915H29.5686L29.2635 26.5316C28.9652 26.6708 28.6939 26.8604 28.4616 27.0916L24.5376 30.9632C24.0208 31.45 23.934 32.233 24.3319 32.8185C24.7949 33.4424 25.6829 33.5779 26.3153 33.121C26.3664 33.0841 26.415 33.0439 26.4606 33.0005L33.5564 25.9995C34.111 25.453 34.1115 24.5664 33.5575 24.0193L26.4606 17.0171C25.9056 16.4711 25.0071 16.4723 24.4536 17.0199C24.4101 17.063 24.3694 17.1088 24.3319 17.1571C23.934 17.7426 24.0208 18.5257 24.5376 19.0124L28.4545 22.891C28.6628 23.0967 28.9022 23.2691 29.1641 23.4021L29.5899 23.5911H17.5418C16.8168 23.5645 16.1808 24.0642 16.0446 24.7673C15.9191 25.5306 16.4446 26.2498 17.2182 26.3736Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-right.d3de867b4c206321955e3dc861a2ee9f.svg";